import { ICreateInvoiceData, ICustomer, ItemInput } from '../../@types';
import React from 'react';
import { createInvoice } from '../../backend-services';

export type InvoiceValidationErrors = {
  [K in keyof ICreateInvoiceData]: string | undefined;
};

export const validateInvoiceDraftForm = (
  formData: ICreateInvoiceData,
  setValidationResults: React.Dispatch<React.SetStateAction<InvoiceValidationErrors>>,
): boolean => {
  const errors: InvoiceValidationErrors = {
    customerId: formData.customerId ? undefined : 'Select a Customer',
    invoiceDueAt: formData.invoiceDueAt ? undefined : 'Due Date is required',
    invoiceNumber: formData.invoiceNumber ? undefined : 'Autogenerate an Invoice Number',
    description: undefined,
    currency: formData.currency ? undefined : 'Currency is required',
    additionalInformation: undefined,
    discount: undefined,
    inventories: undefined,
    issueDate:new Date(formData.issueDate || "").toISOString() ,
    isReoccurring: undefined,
    isReoccurringEndDate: undefined,
    isReoccurringStartDate: undefined,
    reoccurringGroupName: undefined,
    status: undefined,
    tax: undefined,
    isPaymentCompleted: undefined,
    shouldSendEmail:undefined,
    exchangeRate:undefined
  };
  let isError = false;

  if (!formData.inventories || formData.inventories.length === 0) {
    errors.inventories = 'Add at least one inventory';
    isError = true;
  } else {
    formData.inventories.forEach((item: ItemInput, index: number) => {
      ['id', 'rate', 'quantity'].forEach((field) => {
        if (!item[field]) {
          errors.inventories = `Inventory ${index + 1} is missing ${field}. `;
          isError = true;
        }
      });
    });
  }

  setValidationResults(errors);
  return (
    !errors.customerId &&
    !errors.invoiceDueAt &&
    !errors.invoiceNumber &&
    !errors.description &&
    !errors.currency &&
    !isError
  );
};


export const createInvoiceData = async (formData: ICreateInvoiceData, customer: ICustomer) => {
  const parsedInventories = formData.inventories.map((inventory: { rate: string; quantity: string; amount: string }) => ({
    ...inventory,
    quantity: parseFloat(inventory.quantity),
    rate: parseFloat(inventory.rate),
    amount: parseFloat(inventory.amount),
  }));


  const invoiceData: ICreateInvoiceData = {
    customerId: customer?.id,
    description: formData.description,
    discount: formData.discount ? formData.discount / 100 : undefined,
     tax: formData.tax ? (Number(formData.tax) / 100) : undefined,
     issueDate: new Date(formData.issueDate|| '').toISOString(),
    invoiceDueAt: new Date(formData.invoiceDueAt || '').toISOString(),
    isReoccurring: formData.isReoccurring,
    additionalInformation: formData.additionalInformation,
    status: formData.isReoccurring ? undefined : 'pending',
    isPaymentCompleted: formData.isPaymentCompleted,
    shouldSendEmail:formData.shouldSendEmail,
    shouldSendWhatsApp: formData.shouldSendWhatsApp,
    currency:formData.currency,
    exchangeRate:formData.exchangeRate,
    inventories: parsedInventories,
    ...(formData.isReoccurring && {
      isReoccurringStartDate: new Date().toISOString(), 
      reoccurringGroupName: formData.reoccurringGroupName,
      isReoccurringEndDate: new Date(formData.isReoccurringEndDate || '').toISOString(),
    }),
  };

  return await createInvoice(invoiceData);
};


 
